import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import ErrorPage from 'app/components/ErrorPage';
import MainLayout from 'app/components/layouts/MainLayout';
import { ROUTE, TOP_LEVEL_CATEGORY_ID } from 'app/constants/AdminBrowseConstants';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import { makeHomeListPageRoute } from 'app/helpers/admin/browse/home';
import AdminBrowseCategoriesCreatePageRoute from './AdminBrowseCategoriesCreatePageRoute';
import AdminBrowseCategoriesEditPageRoute from './AdminBrowseCategoriesEditPageRoute';
import AdminBrowseCategoriesListPageRoute from './AdminBrowseCategoriesListPageRoute';
import AdminBrowseHomeCreatePageRoute from './AdminBrowseHomeCreatePageRoute';
import AdminBrowseHomeEditPageRoute from './AdminBrowseHomeEditPageRoute';
import AdminBrowseHomeListPageRoute from './AdminBrowseHomeListPageRoute';

const DEFAULT_TOP_LEVEL_CATEGORY_ID = TOP_LEVEL_CATEGORY_ID.COLLECTION;

export default (
  <Route path={ROUTE.ADMIN}>
    <MainLayout>
      <Switch>
        <Route exact path={ROUTE.ADMIN_BROWSE}>
          <Redirect to={makeHomeListPageRoute('')} />
        </Route>

        <Route path={ROUTE.ADMIN_BROWSE_HOME_LIST}>
          <Switch>
            <Route exact path={ROUTE.ADMIN_BROWSE_HOME_LIST}>
              <AdminBrowseHomeListPageRoute />
            </Route>
            <Route exact path={ROUTE.ADMIN_BROWSE_HOME_CREATE}>
              <AdminBrowseHomeCreatePageRoute />
            </Route>
            <Route exact path={ROUTE.ADMIN_BROWSE_HOME_EDIT}>
              <AdminBrowseHomeEditPageRoute />
            </Route>
            <Route>
              <ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />
            </Route>
          </Switch>
        </Route>

        <Route path={ROUTE.ADMIN_BROWSE_CATEGORIES}>
          <Switch>
            <Route exact path={ROUTE.ADMIN_BROWSE_CATEGORIES}>
              <Redirect to={`${ROUTE.ADMIN_BROWSE_CATEGORIES}/${DEFAULT_TOP_LEVEL_CATEGORY_ID}`} />
            </Route>

            <Route exact path={`${ROUTE.ADMIN_BROWSE_CATEGORIES}/:topLevelCategoryId`}>
              <AdminBrowseCategoriesListPageRoute basePageRoute={ROUTE.ADMIN_BROWSE_CATEGORIES} />
            </Route>

            <Route exact path={`${ROUTE.ADMIN_BROWSE_CATEGORIES}/:topLevelCategoryId/:localeCode/create`}>
              <AdminBrowseCategoriesCreatePageRoute basePageRoute={ROUTE.ADMIN_BROWSE_CATEGORIES} />
            </Route>

            <Route exact path={`${ROUTE.ADMIN_BROWSE_CATEGORIES}/:topLevelCategoryId/:localeCode/:categoryConfigId`}>
              <AdminBrowseCategoriesEditPageRoute basePageRoute={ROUTE.ADMIN_BROWSE_CATEGORIES} />
            </Route>
          </Switch>
        </Route>

        <Route>
          <ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />
        </Route>
      </Switch>
    </MainLayout>
  </Route>
);
